export default {
  equipments: [],
  models: [{id: 1, name: 'Argos'}, {id: 2, name: 'u2pass'}]
}
